













import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    itemType: String
  },
  setup(props) {
    return {};
  }
});
